export default __webpack_public_path__ + "static/media/DE3.d93c40d9.svg";